function getErrorMessageFromApi(error) {
    const { response: { data: { detail } } } = error
    return detail
}

function isEmptyResponse(response) {
    return Object.keys(response || {}).length === 0;
}

export { getErrorMessageFromApi, isEmptyResponse }
